import styled from 'styled-components';

export const P = styled.p`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: left;
  color: ${props => props.color ?? props.theme.colors.black};
`;
